const Employees = [
    {
        id:"1",
        Name:"Manoj Deshwal",
        Age:"30"
    },{
        id:"2",
        Name:"Virat Kohli",
        Age:"32"
    },{
        id:"3",
        Name:"Rohit Sharma",
        Age:"33"
    }
]

export default Employees;